<template>
  <div id="app">
    <router-view style="padding-bottom: 50px"/>
    <!--    <van-tabbar v-model="active" style="width: 100%;">-->
    <!--      <van-tabbar-item icon="home-o" ><router-link :to="{path:'/'}" tag="div">首页</router-link></van-tabbar-item>-->
    <!--      <van-tabbar-item icon="search" ><router-link :to="{path:'/Resource'}" tag="div">资源库</router-link></van-tabbar-item>-->
    <!--      <van-tabbar-item icon="setting-o" ><router-link :to="{path:'/integral'}" tag="div">积分商城</router-link></van-tabbar-item>-->
    <!--      <van-tabbar-item icon="friends-o" ><router-link :to="{path:'/my'}" tag="div">我的</router-link></van-tabbar-item>-->
    <!--    </van-tabbar>-->
    <foot v-if="isShowBack"></foot>
  </div>
</template>

<script>
  var that;
  import foot from './components/foot'

  var that;
  export default {
    name: 'App',
    data() {
      return {
        active: '0',
        isShowBack: true
      }
    },
    created() {
      // this.getcity()
      if (this.$route.query.code == null) {
        this.getdata()
      } else if (this.$route.query.code != null) {
        console.log("有code",this.$route.query.code)
        this.getcity()
      }
    },
    methods: {
      getdata() {
        var that = this;
        this.myrequest({
          url: "/client/getsign.action",
          types: "post",
          data: {},
          succ: (res) => {

            console.log("aaa",res);
            that.$store.state.Access_token = res.Access_token
            that.$store.state.appid = res.appid
            that.$store.state.nonceStr = res.nonceStr
            that.$store.state.signature = res.signature
            that.$store.state.ticket = res.ticket
            that.$store.state.timestamp = res.timestamp
            that.$store.state.timestamp1 = res.timestamp1
            // this.$store.state.avatar = ""
            // this.$store.state.nickname ="罗超"

            localStorage.setItem("Access_token", res.Access_token)
            localStorage.setItem("appid", res.appid)
            localStorage.setItem("nonceStr", res.nonceStr)
            localStorage.setItem("signature", res.signature)
            localStorage.setItem("ticket", res.ticket)
            localStorage.setItem("timestamp", res.timestamp)
            localStorage.setItem("timestamp1", res.timestamp1)
            // localStorage.setItem("avatar","")
            // localStorage.setItem("nickname", "罗超")
            // this.$store.state.avatar = ""
            // this.$store.state.nickname ="罗超"
            // this.$store.state.token ="623cc9099c1860dbfad18af795907d0f"
            // localStorage.setItem("avatar","")
            // localStorage.setItem("nickname", "罗超")
            // localStorage.setItem("token", "623cc9099c1860dbfad18af795907d0f")

            location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + res.appid + "&redirect_uri="+location.href+"&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
          },
          errs: (msg) => {


          }
        })
      },
      getcity() {

        // var res = {
        //   avatar:"",
        //   nickname:"xxxx",
        //   token:"90b79302faa25e5b98e9fa2e20ba4a7d"
        // }
        //
        // this.$store.state.avatar = res.avatar
        // this.$store.state.nickname = res.nickname
        // this.$store.state.token = res.token
        // console.log(this.$store.state.avatar, 232424)
        //
        // localStorage.setItem("avatar", res.avatar)
        // localStorage.setItem("nickname", res.nickname)
        // localStorage.setItem("token", res.token)
        //
        // console.log(this.$route.query.code, 21321321)

        this.myrequest({
            url:'/client/userlogin.action',
            types:'post',
            data:{
                code:this.$route.query.code
            },
            succ: (res) => {
              console.log(111,res);
                this.$store.state.avatar = res.avatar
                this.$store.state.nickname = res.nickname
                this.$store.state.token = res.token
                localStorage.setItem("avatar", res.avatar)
                localStorage.setItem("nickname", res.nickname)
                localStorage.setItem("token", res.token)
            },
            errs: (msg) => {

            }
        })
      }

    },
    components: {
      foot
    },
    watch: {
      '$route'() {
        that = this;
        // console.log('watch里面',that.$route.name);
        if (that.$route.path == '/comments' || that.$route.path == '/collection' || that.$route.path == '/coupons' || that.$route.path == '/Courses'
          || that.$route.path == '/account' || that.$route.path == '/Mobile' || that.$route.path == '/bank' || that.$route.path == '/video' || that.$route.path == '/purchase'
          || that.$route.path == '/withdrawal' || that.$route.path == '/topup' || that.$route.path == '/purchase' || that.$route.path == '/bofang'||that.$route.path == '/group'||that.$route.path == '/couress'
        ) {
          that.isShowBack = false;
        } else {
          that.isShowBack = true;
        }
      }
    }
  }
</script>

<style>
  #app {
    width: 100%;
    color: #2c3e50;
    font-size: 12px;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue